export default __webpack_public_path__ + "static/media/tick-no-outline.e8d6be0f.svg";